import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DocumentiSearchDocRow } from 'src/app/shared/models/documento-search.model';

@Component({
  selector: 'app-documenti-selected-list',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template:`
      <p-table  [value]="data()" [totalRecords]="data().length" [paginator]="true" [rows]="10">
        <ng-template pTemplate="header">
          <tr>
            <th id="protocollo" style="width:'180px';">Protocollo</th>
            <th id="dataDocumento" style="width:'90px';">Data</th>
            <th id="classifica" style="width:'180px';">Classifica</th>
            <!-- <th id="oggetto">Oggetto</th> -->
            <th id="action-buttons"></th>      
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-rowData>
          <tr>      
            <td class="trunc" [pTooltip]="getRowTooltip('protocollo', rowData)" tooltipPosition="top" [showDelay]="200">
              {{rowData['protocollo']}}
            </td>

            <td>{{rowData['dataDocumento'] | date: 'dd/MM/yyyy'}}</td>

            <td class="trunc" [pTooltip]="getRowTooltip('classifica', rowData)" tooltipPosition="top" [showDelay]="200">
              {{rowData['classifica']}}
            </td>

            <!-- <td class="trunc" [pTooltip]="getRowTooltip('oggetto', rowData)" tooltipPosition="top" [showDelay]="200">
              {{rowData['oggetto']}}
            </td> -->
            
            <td class="action-buttons" style="text-align:end;">
              <button pButton type="button" title="Elimina" icon="fas fa-check" class="p-button-danger" (click)="unselected.emit(rowData)"></button>
            </td>
          </tr>
        </ng-template>

        <!-- <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between">
                Documenti Selezionati {{data() ? data().length : 0 }}
            </div>
        </ng-template> -->

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan=4>
              Nessun documento selezionato
            </td>
          </tr>
        </ng-template>
      </p-table>
  `,
  styles:[
    `
      :host ::ng-deep td {
        padding: 0.25em 0.5em !important;
        text-align: center;
      }

      .action-buttons {
        display: flex;
        gap: 5px;
      }

      .trunc {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }    
    `
  ]
})
export class DocumentiListSelectedComponent {
  data = input<DocumentiSearchDocRow[]>([]);
  unselected = output<DocumentiSearchDocRow>();

  constructor() {}

  getRowTooltip(colName: keyof DocumentiSearchDocRow, rowData: DocumentiSearchDocRow): string | undefined {

    const value : string|undefined = rowData[colName]?rowData[colName] as string:undefined;

    if ( value ) {
      if (value.length > 10) {
        return value;
      }
    }
    return undefined;
  }  
}